import {
  getIntegrationConfig,
  saveIntegrationConfig,
  startIntegrationProcess,
  stopIntegrationProcess,
} from 'service/InstallerApp/index';

/**
 * Update Micro-service configuration
 * @param entity
 * @param version
 * @param value
 * @returns {Promise<null|Error>}
 */
export const updateMSConfiguration = async (entity, version, value) => {
  try {
    const { data } = await getIntegrationConfig(entity, version);
    const oldConfig = JSON.parse(data.config);

    const newConfig = JSON.stringify({ ...oldConfig, ...value });

    if (oldConfig !== newConfig) {
      saveIntegrationConfig(entity, version, newConfig);
      await stopIntegrationProcess(entity, version);
      await startIntegrationProcess(entity, version);
    }
    return null;
  } catch (err) {
    return err;
  }
};
